import { Website, WebsiteFilter, WebsiteFormData } from "types/website.types";
import apiClient from "../../api/apiClient";
import { API_ENDPOINTS } from "../../api/endPoints";

export const getWebsites = async (): Promise<Website[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.WEBSITES.LIST);
  return response.data;
};

export const getFilteredWebsites = async (filters: WebsiteFilter): Promise<Website[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.WEBSITES.FILTER, {
    params: filters,
  });
  return response.data;
};

export const getWebsiteById = async (id: string): Promise<Website> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.WEBSITES.DETAIL(id));
  return response.data;
};

export const getWebsitesByPublisher = async (publisherId: string): Promise<Website[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.WEBSITES.BY_PUBLISHER(publisherId));
  return response.data;
};

export const createNewWebsite = async (data: WebsiteFormData): Promise<Website> => {
  const response = await apiClient.post(API_ENDPOINTS.PUBLISHER.WEBSITES.CREATE, data);
  return response.data;
};

export const updateExistingWebsite = async (id: string, data: WebsiteFormData): Promise<Website> => {
  const response = await apiClient.put(API_ENDPOINTS.PUBLISHER.WEBSITES.UPDATE(id), data);
  return response.data;
};

export const deleteExistingWebsite = async (id: string): Promise<void> => {
  await apiClient.delete(API_ENDPOINTS.PUBLISHER.WEBSITES.DELETE(id));
};

/**
 * Tests the provided DOM selectors against a website URL
 * @param websitePK The URL of the website to test
 * @param selectors The DOM selectors to test
 * @returns Promise with test results
 */
export const collectNow = async (websitePK: string, collectionType: 'incremental' | 'full' = 'incremental') => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.PUBLISHER.WEBSITES.COLLECT_NOW, {
      websitePK,
      scrapeMode: collectionType
    });
    return response.data;
  } catch (error) {
    console.error("Error collecting now on website:", error);
    throw error;
  }
};
/**
 * Tests the provided DOM selectors against a website URL
 * @param websitePK The URL of the website to test
 * @param selectors The DOM selectors to test
 * @returns Promise with test results
 */
export const testWebsiteSelectors = async (
  websitePK: string,
  selectors: {
    articleContainer?: string;
    headline?: string;
    subheadline?: string;
    content?: string;
    publishDate?: string;
    author?: string;
    image?: string;
    category?: string;
    fullArticleContent?: string;
    fullArticleImage?: string;
  }
) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.PUBLISHER.WEBSITES.TEST, {
      websitePK,
      selectors,
    });
    return response.data;
  } catch (error) {
    console.error("Error testing website selectors:", error);
    throw error;
  }
};
